import { imgBaseURL } from 'helper/Utility'
import { defaultIMG } from 'helper/Utility'
const ImgTable = ({image}) => {
  return (
    <><img src={image ? imgBaseURL() + image : defaultIMG} alt="" style={{ width: '50px', height: '50px', borderRadius: '100px', objectFit: 'cover' }} /></>
  )
}

export default ImgTable